module.exports = __webpack_public_path__ + "img/ic_drawer_3_checked.465686a7.svg";